import {Component, EventEmitter, Input, OnChanges, Output, SimpleChange, ViewChild} from "@angular/core";
import {ToastrService} from "ngx-toastr";
import {ClassificationType} from "../../../../models/classification-type";
import {ClassificationControllerService} from "../../../../services/classifications-controller/classification-controller.service";
import {BaseError} from "../../base-error";

@Component({
  selector: "classification-new",
  templateUrl: "./classification-type-new.component.html",
  providers: [],
  styles: [],
})
export class ClassificationTypeNewModalComponent extends BaseError implements OnChanges {
  @Output() public formSubmit = new EventEmitter();
  public visibleWindow = "newClassificationTypeWindow";
  @Input() public classificationType: ClassificationType;
  @Output() public closeClassificationTypeWindow = new EventEmitter();
  @ViewChild("lgModal") public childModal;

  constructor(private classificationControllerService: ClassificationControllerService,
              toastr: ToastrService) {
    super(toastr);
  }

  public ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    if (changes.classificationType && changes.classificationType.currentValue) {
      this.classificationType = changes.classificationType.currentValue;
    } else {
      this.classificationType = new ClassificationType();
    }
  }

  public save() {
    if (this.classificationType.id === undefined) {
      this.createClassificationType(this.classificationType);
    } else {
      this.updateClassificationType(this.classificationType);
    }
  }

  public cancel() {
    this.formSubmit.emit({
      save: false,
    });
    this.childModal.hide();
  }

  public createClassificationType(classificationType: ClassificationType) {
    this.classificationControllerService.createClassificationType(classificationType).subscribe(
      (data) => this.formSubmit.emit({save: true, classificationType}),
      (error) => this.showErrorMessageWithTitle("Error HTTP Post Service" , error),
    );
    this.childModal.hide();
  }

  public updateClassificationType(classificationType: ClassificationType) {
    this.classificationControllerService.updateClassificationType(classificationType).subscribe(
      (data) => this.formSubmit.emit({save: true, classificationType}),
      (error) => this.showErrorMessageWithTitle("Error HTTP Post Service ", error),
    );
    this.childModal.hide();
  }

  public deleteClassificationType(isConfirmed) {
    if (isConfirmed) {
      this.classificationControllerService.deleteClassificationType(this.classificationType.id).subscribe(
        (data) => this.formSubmit.emit({save: false, classificationType: undefined}),
        (error) => this.showErrorMessageWithTitle("Error with Service saving", error),
      );
    }
    this.childModal.hide();
  }

  public classificationOnFormSelected(selected: any) {
    if (this.classificationType) {
      this.classificationType.classificationOnForm = selected;
    }
  }

  public initData() {
    this.childModal.config.backdrop = true;
    this.childModal.show();
  }

  public initDataForAdd() {
    this.classificationType = new ClassificationType();
    this.childModal.config.backdrop = true;
    this.childModal.show();
  }

}
